"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const ArgusHoverMenu_1 = tslib_1.__importDefault(require("./ArgusHoverMenu"));
const ArgusMenuCategory_1 = tslib_1.__importDefault(require("./ArgusMenuCategory"));
const ArgusMenuGroup_1 = tslib_1.__importDefault(require("./ArgusMenuGroup"));
const ArgusMenuGroupUser_1 = tslib_1.__importDefault(require("./ArgusMenuGroupUser"));
const ArgusMenuItem_1 = tslib_1.__importDefault(require("./ArgusMenuItem"));
const ArgusMenuLogo_1 = tslib_1.__importDefault(require("./ArgusMenuLogo"));
const ArgusMenuSearch_1 = tslib_1.__importDefault(require("./ArgusMenuSearch"));
const ArgusMenuComponentSwitch = ({ items, open }) => (react_1.default.createElement(react_1.default.Fragment, null, items?.map((item) => {
    switch (item.kind) {
        case "link":
            return (react_1.default.createElement(ArgusHoverMenu_1.default, { key: item.label, ...{ openMenu: open, menuItems: [item] } },
                react_1.default.createElement(ArgusMenuItem_1.default, { ...{ ...item, open } })));
        case "group":
            return (react_1.default.createElement(ArgusHoverMenu_1.default, { key: item.label, ...{ openMenu: open, menuItems: item?.items } },
                react_1.default.createElement(ArgusMenuGroup_1.default, { ...{ ...item, open } })));
        case "logo":
            return react_1.default.createElement(ArgusMenuLogo_1.default, { key: item.label, ...{ ...item, open } });
        case "search":
            return react_1.default.createElement(ArgusMenuSearch_1.default, { key: item.label, ...{ ...item, open } });
        case "category":
            return react_1.default.createElement(ArgusMenuCategory_1.default, { key: item.label, ...{ ...item, open } });
        case "user":
            return (react_1.default.createElement(ArgusHoverMenu_1.default, { key: item.label, ...{ openMenu: open, menuItems: item.items } },
                react_1.default.createElement(ArgusMenuGroupUser_1.default, { key: item.label, ...{ ...item, open } })));
        default:
            return null;
    }
})));
exports.default = ArgusMenuComponentSwitch;
